import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { intl } from '@savgroup-front-common/core/helpers';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getAdditionalInformationEntitiesSummariesRequest } from '../../api/Claim/getAdditionalInformationEntitiesSummariesCommand';

import * as actionTypes from './actionTypes';

function* getAdditionalInformationEntitiesSummariesWorker({ payload }) {
  const { indexer, ids } = payload;
  const meta = { indexer };

  if (ids.length === 0) {
    return;
  }

  yield executeSagaRequest(
    actionTypes.GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES,
    getAdditionalInformationEntitiesSummariesRequest({
      ids,
      cultureName: intl.locale,
    }),
    meta,
  );
  yield put(
    actionTypes.GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES.end(meta),
  );
}

function* getAdditionalInformationEntitiesSummariesWatcher() {
  yield takeEvery(
    actionTypes.GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES.BASE,
    getAdditionalInformationEntitiesSummariesWorker,
  );
}

export default function* mainSaga() {
  try {
    yield all([getAdditionalInformationEntitiesSummariesWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
